import Utils from 'src/utils';
import { selectUserId } from 'src/store/selectors/userInfo';
import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';
import store from '../index';
const REQUEST_WITH_LINES = 'Requests/RequestWithLines';
const REQUESTS = 'Requests';
const REQUEST_STATUS = 'RequestStatus';
const UPDATE_REQUEST_STATUS = 'RequestStatus/UpdateRequestStatus';
const UPDATE_REQUEST_LINE_STATUS = 'RequestStatus/UpdateRequestLineStatus';
export const SAVE_OWN_STATEMENTS = 'SAVE_OWN_STATEMENTS';
export const SAVE_STATEMENTS = 'SAVE_STATEMENTS';
export const CREATE_STATEMENT = 'CREATE_STATEMENT';
export const UPDATE_STATEMENT = 'UPDATE_STATEMENT';
export const DELETE_STATEMENT = 'DELETE_STATEMENT';
export const UPDATE_STATEMENT_REQUEST_LINE_STATUS = 'UPDATE_STATEMENT_REQUEST_LINE_STATUS';
const saveOwnStatements = (list) => ({
    type: SAVE_OWN_STATEMENTS,
    payload: list
});
const saveStatements = (list) => ({
    type: SAVE_STATEMENTS,
    payload: list
});
const createStatement = (statement) => ({
    type: CREATE_STATEMENT,
    payload: statement
});
const updateStatement = (statement) => ({
    type: UPDATE_STATEMENT,
    payload: statement
});
const deleteStatement = (statementId) => ({
    type: DELETE_STATEMENT,
    payload: statementId
});
const updateStatementRequestLineStatus = (status, parentRequestId) => ({
    type: UPDATE_STATEMENT_REQUEST_LINE_STATUS,
    payload: {
        status,
        parentRequestId
    }
});
function showOperationFailNotificationAndReturnReject(error) {
    toastrError(error);
    return Promise.reject();
}
export function getOwnStatementsAction() {
    const currentUserId = selectUserId(store.getState());
    return (dispatch) => communicate({
        url: REQUESTS,
        method: 'get',
        getParams: Utils.objects.objectToQueryString({ userIds: currentUserId, isDeleted: false })
    })
        .then(({ data }) => data?.Data)
        .then((list = []) => {
        dispatch(saveOwnStatements(list));
        return Promise.resolve(list);
    })
        .catch((error) => {
        dispatch(saveOwnStatements([]));
        toastrError(error);
        return Promise.reject();
    });
}
export function loadStatementsAction(params) {
    return (dispatch) => communicate({
        url: REQUESTS,
        method: 'get',
        getParams: Utils.objects.objectToQueryString(params)
    })
        .then(({ data }) => data?.Data)
        .then((list = []) => {
        dispatch(saveStatements(list));
        return Promise.resolve(list);
    })
        .catch((error) => {
        dispatch(saveStatements([]));
        toastrError(error);
        return Promise.reject();
    });
}
export function loadStatementAction(statementId) {
    return (dispatch) => communicate({
        url: REQUESTS,
        method: 'get',
        getParams: Utils.objects.objectToQueryString({ ids: statementId })
    })
        .then(({ data }) => data?.Data[0])
        .then((statement) => {
        dispatch(updateStatement(statement));
        return Promise.resolve(statement);
    })
        .catch((error) => {
        toastrError(error);
        return Promise.reject();
    });
}
export function createStatementAction(payload) {
    return (dispatch) => communicate({
        url: REQUEST_WITH_LINES,
        method: 'post',
        data: payload
    })
        .then(({ data }) => {
        toastrSuccess(data);
        return data?.Data?.[0];
    })
        .then((statement) => {
        dispatch(createStatement(statement));
        return Promise.resolve(statement);
    })
        .catch(showOperationFailNotificationAndReturnReject);
}
export function putStatementAction(payload) {
    return (dispatch) => communicate({
        url: REQUEST_WITH_LINES,
        method: 'put',
        data: payload
    })
        .then(({ data }) => {
        toastrSuccess(data);
        return data?.Data?.[0];
    })
        .then((statement) => {
        dispatch(updateStatement(statement));
        return Promise.resolve(statement);
    })
        .catch(showOperationFailNotificationAndReturnReject);
}
export function deleteStatementAction(statementId) {
    return (dispatch) => communicate({
        url: REQUEST_WITH_LINES,
        method: 'delete',
        getParams: Utils.objects.objectToQueryString({ id: statementId })
    })
        .then((response) => {
        dispatch(deleteStatement(statementId));
        toastrSuccess(response);
        return Promise.resolve();
    })
        .catch(showOperationFailNotificationAndReturnReject);
}
export function postStatementStatus(payload) {
    return (dispatch) => communicate({
        url: REQUEST_STATUS,
        method: 'post',
        data: payload
    })
        .then(({ data }) => {
        toastrSuccess(data);
        return data?.Data;
    })
        .then((status) => dispatch(loadStatementAction(status.TypeValueId)))
        .catch(showOperationFailNotificationAndReturnReject);
}
export function postStatementLineStatus(payload, parentRequestId) {
    return (dispatch) => communicate({
        url: REQUEST_STATUS,
        method: 'post',
        data: payload
    })
        .then(({ data }) => {
        toastrSuccess(data);
        return data?.Data;
    })
        .then((status) => {
        dispatch(updateStatementRequestLineStatus(status, parentRequestId));
        return Promise.resolve(status);
    })
        .catch(showOperationFailNotificationAndReturnReject);
}
export function putStatementStatus(payload) {
    return (dispatch) => communicate({
        url: UPDATE_REQUEST_STATUS,
        method: 'put',
        data: payload
    })
        .then(({ data }) => {
        toastrSuccess(data);
        return data?.Data;
    })
        .then((status) => dispatch(loadStatementAction(status.TypeValueId)))
        .catch(showOperationFailNotificationAndReturnReject);
}
export function putStatementLineStatus(payload, parentRequestId) {
    return (dispatch) => communicate({
        url: UPDATE_REQUEST_LINE_STATUS,
        method: 'put',
        data: payload
    })
        .then(({ data }) => {
        toastrSuccess(data);
        return data?.Data;
    })
        .then((status) => {
        dispatch(updateStatementRequestLineStatus(status, parentRequestId));
        return Promise.resolve(status);
    })
        .catch(showOperationFailNotificationAndReturnReject);
}
